import { Route } from 'react-router';
import {
  PromoDetailsPage,
  PromosPage,
  PublicPromosPage,
} from '@bonanza-social/promos/pages';
import { Promos } from '@bonanza-social/promos';
import { withPrizeWallCampaign } from '@bonanza-social/prize-wall';
import DynamicRoute from './DynamicRoute';

const EnhancedPromosPage = withPrizeWallCampaign(Promos, PromosPage);

export const renderPromosRoutes = () => (
  <Route path="promos">
    <Route
      index
      element={
        <DynamicRoute
          AnonymousComponent={PublicPromosPage}
          AuthenticatedComponent={EnhancedPromosPage}
        />
      }
    />
    <Route path=":id" element={<PromoDetailsPage />} />
  </Route>
);
